module.exports = __webpack_public_path__ + "img/uk_gas_consumption.e5e416fa.jpg";